import { render, staticRenderFns } from "./index10.vue?vue&type=template&id=324ca5a6&scoped=true"
import script from "./index10.vue?vue&type=script&lang=js"
export * from "./index10.vue?vue&type=script&lang=js"
import style0 from "./index10.vue?vue&type=style&index=0&id=324ca5a6&prod&lang=scss"
import style1 from "./index10.vue?vue&type=style&index=1&id=324ca5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ca5a6",
  null
  
)

export default component.exports